// Декларативният потвърждаващ диалог (`open` от родителя) — за въпросите със
// собствено състояние: анулиране с причина, недостиг при разнасяне, проблемни
// продукти, незавършена чернова. Шелът е antd Modal, затова пазачът за слой
// (`hasOpenOverlay`) го вижда и клавишите на листа зад него мълчат; тялото е
// `ConfirmPanel` през `modalRender` — същото като при `useConfirm`.
// Esc е на панела (с preventDefault), затова antd `keyboard` е изключен.
import { useRef } from "react";
import { Modal } from "antd";
import { useViewport } from "../../../../hooks/useViewport";
import { modalStyles, modalWrapStyle } from "../../../../utils/modalStyles";
import { ConfirmPanel, type ConfirmPanelProps } from "./ConfirmPanel";
import { confirmDialogWidth } from "./confirmLayout";

type Props = Omit<ConfirmPanelProps, "isActive"> & {
  open: boolean;
  afterClose?: () => void;
  // клик по фона = отказ (по подразбиране); false — при написана причина и т.н.
  maskClosable?: boolean;
};

export const ConfirmDialog = ({ open, afterClose, maskClosable = true, ...panel }: Props) => {
  const viewport = useViewport();
  // Панелът не се пререндерира, докато модалът се затваря (rc-dialog мемоизира
  // съдържанието) — затова активността се чете през ref, не през prop.
  const openRef = useRef(open);
  openRef.current = open;
  return (
    <Modal
      open={open}
      onCancel={() => {
        if (!panel.busy) panel.onCancel();
      }}
      afterClose={afterClose}
      footer={null}
      centered
      closable={false}
      keyboard={false}
      maskClosable={maskClosable}
      destroyOnHidden
      width={confirmDialogWidth(viewport)}
      style={modalWrapStyle}
      styles={{ mask: modalStyles.mask }}
      modalRender={() => <ConfirmPanel {...panel} isActive={() => openRef.current} />}
    />
  );
};

export default ConfirmDialog;
